import { FC } from 'react';
import { Flex } from '@/_components/Flex';
import { Text } from '@/_components/Text';
import { Icon } from '@/_components/Icon';
import { OVERVIEW_TABLE_HEADER_MAP } from '@/_constants/overview';
import { useSortableItem } from '@/_hooks/useSortableItem';
import styles from './SortableColumnItem.module.css';
import { SortableColumnItemProps } from './SortableColumnItem.types';

export const SortableColumnItem: FC<SortableColumnItemProps> = ({ item }) => {
  const { attributes, listeners, setNodeRef, style } = useSortableItem(item.id);

  return (
    <Flex
      isYCentered={true}
      gap={2}
      className={styles.columnEditorItem}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <Icon name="grab" size={16} color="secondary" />
      <Text type="small">{OVERVIEW_TABLE_HEADER_MAP[item.content]}</Text>
    </Flex>
  );
};
